import React, { useState } from 'react';

const Services = () => {
  const [openModal, setOpenModal] = useState(null);

  const services = [
    {
      title: 'VectorScope',
      description: 'Track mosquito traps, manage collections, and characterize samples in real-time.',
      image: '/images/mosquito-app.jpg',
      features: [
        'Real-time trap monitoring and data visualization',
        'Seamless lab integration for sample characterization',
        'Cloud-based analytics for rapid decision-making',
      ],
    },
    {
      title: 'SORMAS for Dengue',
      description: 'Customized to monitor, track, and respond to dengue outbreaks in Kenya.',
      image: '/images/dengue.jpg',
      features: [
        'Real-time outbreak tracking',
        'Customized alerts for rapid response',
        'Integration with national health systems',
      ],
    },
    {
      title: 'EpiTech Tool',
      description: 'Digital consenting and participant enrollment with secure data management.',
      image: '/images/epitech.jpg',
      features: [
        'Digital consent forms',
        'Secure participant data management',
        'User-friendly interface for researchers',
      ],
    },
    {
      title: 'Model Digital Lab',
      description: 'Efficient molecular workflows with seamless data sharing.',
      image: '/images/digital-lab.jpg',
      features: [
        'Streamlined molecular workflows',
        'Real-time data sharing',
        'Scalable for large labs',
      ],
    },
  ];

  const handleOpenModal = (title) => {
    setOpenModal(title);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16 text-blue-800">Our Digital Platforms</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`border rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-2 bg-white ${
                service.title === 'VectorScope' ? 'border-teal-500' : 'border-gray-200'
              }`}
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-52 object-cover rounded-lg mb-6"
                loading="lazy"
              />
              <h3 className="text-2xl font-semibold mb-3 text-blue-700">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <ul className="text-gray-700 mb-6 list-disc pl-5 space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <button
                onClick={() => handleOpenModal(service.title)}
                className="text-teal-500 hover:text-teal-700 font-semibold transition-colors"
              >
                Learn More
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Modal with fade-in */}
      {services.map((service, index) => (
        <div
          key={index}
          className={`fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 transition-opacity duration-300 ${
            openModal === service.title ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <div className="bg-white p-8 rounded-xl max-w-lg w-full relative transform transition-transform duration-300 scale-100">
            <button
              onClick={handleCloseModal}
              className="absolute top-4 right-6 text-3xl font-bold text-gray-600 hover:text-gray-800"
              aria-label="Close modal"
            >
              &times;
            </button>
            <h3 className="text-2xl font-semibold mb-4 text-blue-700">{service.title}</h3>
            <p className="text-gray-600 mb-6">{service.description}</p>
            <ul className="text-gray-700 mb-6 list-disc pl-5 space-y-2">
              {service.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <a
              href="#contact"
              className="bg-teal-500 text-white px-6 py-3 rounded-full hover:bg-teal-600 transition-all duration-300"
            >
              Request a Demo
            </a>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Services;